import { createSlice } from '@reduxjs/toolkit';

import { fetchTableConfigAction } from '@pp/core/src/store/apiActions/fetchTableConfigAction';

const initialState: {
  broadcasterWsAddress: string;
  aamsTicket: string | null;
  aamsSessionId: string | null;
  perPayoutBetMaxLimit?: number;
  customMultiplierCap?: number;
  subtitlesAvailable: boolean;
  maxMultiplier: number;
} = {
  broadcasterWsAddress: '',
  aamsTicket: '',
  aamsSessionId: '',
  perPayoutBetMaxLimit: 0,
  customMultiplierCap: 0,
  subtitlesAvailable: false,
  maxMultiplier: 1000000,
};

export const gameConfigSlice = createSlice({
  name: 'gameConfig',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTableConfigAction.fulfilled, (state, action) => {
      const tableConfigRaw = action.payload.rawResponse;
      state.broadcasterWsAddress = tableConfigRaw.params.broadcaster_ws + '/broadcast';
      state.aamsTicket = tableConfigRaw.params.aamsTicket;
      state.aamsSessionId = tableConfigRaw.params.aamsSessionId;
      state.perPayoutBetMaxLimit = tableConfigRaw.params.per_bet_payout_max;
      state.customMultiplierCap = tableConfigRaw.params.custommultipliercap;
      state.subtitlesAvailable = tableConfigRaw.params.subtitles_available === true;
      state.maxMultiplier = tableConfigRaw.params.max_multiplier;
    });
  },
});

export const gameConfigActions = gameConfigSlice.actions;
